import api from "../utils/api";
import store from "../redux/store";
import { setCredentials } from "../redux/slices/authSlice";

// Re-reads the logged-in user's modules from the server and puts them in Redux — the sidebar and the routes
// (App.jsx) are built from that list, so a module that was just created / edited / deleted shows up (or goes)
// straight away, without logging in again. Best effort: a failure leaves the current list untouched.
export async function refreshMyModules() {
  try {
    const res = await api.get("/api/auth/my-modules");
    if (Array.isArray(res.data?.modules)) store.dispatch(setCredentials({ modules: res.data.modules }));
  } catch { /* keep the current modules */ }
}
